/**
 * Headphone confirmation, per input device.
 *
 * Audio capture plays a click for the whole take and segments everything the microphone hears into
 * notes. Through a speaker, the click is captured on every beat and written into the melody as a
 * note on every beat - the failure is not "a bit of bleed", it is a melody made of the metronome.
 * So the microphone does not open until the user confirms.
 *
 * The confirmation is stored against the device LABEL, because that is what it is a fact about: a
 * user who confirmed for their audio interface has said nothing about the laptop's built-in
 * microphone, and a tool that carried the confirmation across would silently stop asking exactly
 * when the setup changed.
 *
 * A device the browser has not named yet - which is every device before the first permission grant
 * - is never treated as confirmed and is never stored. The first capture on a machine therefore
 * always asks, which is the right way round.
 *
 * Spec: docs/superpowers/specs/2026-09-08-melody-plugin-design.md §5
 */

export const hasHeadphoneConsent = (confirmed: string[] | undefined, deviceLabel: string | null): boolean =>
  Boolean(deviceLabel) && (confirmed ?? []).includes(deviceLabel ?? '')

export const withHeadphoneConsent = (confirmed: string[] | undefined, deviceLabel: string | null): string[] => {
  const current = confirmed ?? []
  if (!deviceLabel || current.includes(deviceLabel)) {
    return current
  }
  return [...current, deviceLabel]
}
